import React from 'react';
import { WindowData } from '../hooks/useOS';
import { OSWindow } from './OSWindow';

interface WindowManagerProps {
  windows: WindowData[];
  fullScreenShellOverlayActive?: boolean;
  startMenuOpen?: boolean;
  contextMenuVisible?: boolean;
  onClose: (windowId: string) => void;
  onMinimize: (windowId: string) => void;
  onMaximize: (windowId: string) => void;
  onBoundsChange: (windowId: string, bounds: { x: number; y: number; width: number; height: number }) => void;
  onFocus: (windowId: string) => void;
  onOpenWindow?: (appId: string, title: string, filePath?: string, content?: string) => void;
  onBackgroundChange?: (background: string) => void;
  onShowSplash?: (show: boolean) => void;
}

export const WindowManager: React.FC<WindowManagerProps> = ({
  windows,
  fullScreenShellOverlayActive = false,
  startMenuOpen = false,
  contextMenuVisible = false,
  onClose,
  onMinimize,
  onMaximize,
  onBoundsChange,
  onFocus,
  onOpenWindow,
  onBackgroundChange,
  onShowSplash
}) => {
  const activeWindowId = windows
    .filter((window) => !window.isMinimized)
    .sort((a, b) => a.zIndex - b.zIndex)
    .at(-1)?.id;

  return (
    <>
      {windows.map((window) => (
        <OSWindow
          key={window.id}
          window={window}
          isActive={window.id === activeWindowId}
          fullScreenShellOverlayActive={fullScreenShellOverlayActive}
          startMenuOpen={startMenuOpen}
          contextMenuVisible={contextMenuVisible}
          onClose={onClose}
          onMinimize={onMinimize}
          onMaximize={onMaximize}
          onBoundsChange={onBoundsChange}
          onFocus={onFocus}
          onOpenWindow={onOpenWindow}
          onBackgroundChange={onBackgroundChange}
          onShowSplash={onShowSplash}
        />
      ))}
    </>
  );
};